module.exports = __webpack_public_path__ + "img/userProfile.fdd20428.png";